import React from 'react'
import MainForm from '@toasttab/otl/src/components/Form/MainForm/MainForm'
import Heading from '@toasttab/shared/src/components/molecules/Heading/Heading'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { ContentfulFormCategory } from '@toasttab/shared/src/interfaces/ContentfulForms.d'
import { HiddenInfogramModalProps } from './HiddenInfogram.d'

const HiddenInfogramModal = ({
  entryId,
  formFieldset,
  formRedirectUrl,
  handleClose,
  isOpen,
  marketoFormId,
  marketoProgramName
}: HiddenInfogramModalProps) => {
  return (
    <>
      {isOpen && (
        <>
          <div
            className='hidden md:block absolute inset-0 z-10'
            data-testid='HiddenInfogramModal-backdrop'
            onClick={handleClose}
          />
          <div
            className='hidden md:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 bg-white p-6 rounded-lg w-full max-w-[558px] font-sansPro text-base [&_select]:rounded-[4px]'
            data-testid='HiddenInfogramModal'
            role='dialog'
          >
            <Heading
              classes='!mb-1 !mt-0'
              content={formFieldset.title}
              heading='h3'
              textAlign={['text-center']}
            />
            <Typography
              as='p'
              classes='text-base text-center text-secondary font-sansPro !mt-0 mb-4'
            >
              {formFieldset.description.description}
            </Typography>
            <MainForm
              buttonStyle='secondary-otl'
              buttonText={formFieldset.submitLabel}
              conversionType='OTL-DEMO-HEADLESS'
              entryId={entryId}
              formCategory={formFieldset as unknown as ContentfulFormCategory}
              formId={marketoFormId}
              formLayout='twoColumn'
              hideCoreFieldsOnProgressiveForm
              mds
              programName={marketoProgramName}
              redirectUrl={formRedirectUrl}
              typeHandle={formFieldset.__typename}
            />
          </div>
        </>
      )}
    </>
  )
}

export default HiddenInfogramModal
